export default __webpack_public_path__ + "static/media/bkg--location-1-2.7537c206.jpg";